// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bb1ead2b","977":"198bb9de"}[chunkId] + ".chunk.js";
};